import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Redirect } from '../../models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  private http = inject(HttpClient);

  configUrl = environment.apiUrl;

  getRedirections() {
    const route = `${this.configUrl}settings/redirect`;
    return this.http.get<Redirect[]>(route).pipe();
  }

  addRedirect(host: Redirect) {
    const route = `${this.configUrl}settings/redirect`;
    return this.http.post(route, host).pipe();
  }

  deleteRedirect(toDeleteRedirectId: number) {
    const route = `${this.configUrl}settings/redirect`;
    return this.http.delete(route, ({body: {toDeleteRedirectId}})).pipe();
  }
}
